// Lib
import gql from 'graphql-tag';

// Types
import { NOTIFICATION } from '../types';

export const onNotificationSubscription = gql`
  subscription OnNotification {
    onNotification {
      ${NOTIFICATION}
    }
  }
`;
